import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useDisciplines from "./hooks/useDisciplines";

import DisciplineDetails from "./components/DisciplineDetails";
import DisciplineDrawer from "./components/DisciplineDrawer";
import DisciplineForm from "./components/DisciplineForm";
import DisciplinesGrid from "./components/DisciplinesGrid";
import DisciplinesHero from "./components/DisciplinesHero";
import DisciplinesStats from "./components/DisciplinesStats";
import DisciplinesToolbar from "./components/DisciplinesToolbar";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Disciplines() {
  useScrollToTop();
  const {
    loading,
    saving,
    filters,
    setFilter,
    disciplines,
    filteredDisciplines,
    selectedDiscipline,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useDisciplines();

  return (
    <div className="space-y-6">
      <DisciplinesHero
        loading={loading}
        total={disciplines.length}
        withImage={stats.withImage}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshDisciplines}
      />

      {/* <DisciplinesStats loading={loading} stats={stats} /> */}

      <DisciplinesToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={disciplines.length}
        filteredCount={filteredDisciplines.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshDisciplines}
      />

      <DisciplinesGrid
        loading={loading}
        disciplines={filteredDisciplines}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
      />

      <DisciplineDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        discipline={selectedDiscipline}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedDiscipline && (
          <DisciplineDetails
            discipline={selectedDiscipline}
            onEdit={() => actions.openEditDrawer(selectedDiscipline)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <DisciplineForm
            mode="create"
            saving={saving}
            onSubmit={actions.createDiscipline}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedDiscipline && (
          <DisciplineForm
            mode="edit"
            discipline={selectedDiscipline}
            saving={saving}
            onSubmit={actions.updateDiscipline}
            onClose={actions.closeDrawer}
          />
        )}
      </DisciplineDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}